<template>
    <div
        class="flex items-center justify-center rounded-full w-14 h-14 bg-white cursor-pointer"
    >
        <div v-if="$slots.default">
            <slot />
        </div>

        <div v-else>Survey</div>
    </div>
</template>

<script>
export default {};
</script>

<style></style>
